import React from 'react';
import { 
    Filter,
    List, 
    Datagrid,
    TextField, 
    TextInput,
} from 'react-admin';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import frequent from '../controls/Frequency';
import withStyles from '@material-ui/core/styles/withStyles';
import { stringify } from 'query-string';


const styles = {
    link: {
        display: 'inline-flex',
        alignItems: 'center'
    },
};

const    InsFilter = props => (
    <Filter {...props}>
        <TextInput source="name" alwaysOn label='Search by Name'/>
    </Filter>
);

const GetFrequencyText=(freq)=>{
    var result = '';
    for(var item of frequent) {
        if(item.id === freq) {
            result = item.name;
            break;
        }
    }
    return result;
}

const Frequency = ({classes, record})=>{
    let freq = record && record.val_frequency ? JSON.parse(record.val_frequency) : [];
    let ins_id = record && record.ins_id ? record.ins_id : '';
    let code = record && record.code ? record.code : '';
   // console.log(freq)
    return(
        <>
        {

        <Button size="small" color= "primary"  component={Link} key ={code}
            to={{
                pathname: `/log_${code}`,
                search: stringify({
                    page: 1,
                    perPage: 25,
                    sort: 'ins_id',
                    order: 'DESC',
                    filter: JSON.stringify({ ins_id: ins_id }),
                }),
            }}
            className={classes.link}
        >{'MORE >>'}</Button> 
        }
        </>
    )   
}

export const InsList = ({classes, ...props }) => (
    <List 
        {...props}
        filters={<InsFilter />}
        perPage={20}
        bulkActionButtons ={false}
        title ="Log"
        >
        <Datagrid >
            <TextField source="name" label="Name" />
            <Frequency classes={classes} />
        </Datagrid>
    </List>
);


export default withStyles(styles)(InsList)
